import React from 'react';

interface ShareRewindSlideBaseProps {
  year: number;
  children: React.ReactNode;
  backgroundGradient?: string;
}

const ShareRewindSlideBase = React.forwardRef<HTMLDivElement, ShareRewindSlideBaseProps>(
  ({ children, backgroundGradient = 'from-purple-900 via-pink-800 to-orange-700' }, ref) => {
    return (
      <div
        ref={ref}
        data-share-image="true"
        className="relative mx-auto"
        style={{
          width: '1080px',
          height: '1920px',
          fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
          boxSizing: 'border-box',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <div className={`relative w-full h-full bg-gradient-to-b ${backgroundGradient} overflow-hidden`}>
          {/* Decorative Elements */}
          <div className="absolute top-20 right-20 w-32 h-32 bg-white/5 rounded-full"></div>
          <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/5 rounded-full"></div>
          <div className="absolute top-1/2 right-10 w-16 h-16 bg-white/5 rounded-full"></div>

          {/* Content */}
          <div className="relative z-10 flex flex-col h-full px-16">
            {children}
          </div>

          {/* Bottom Accent */}
          <div className="absolute bottom-0 left-0 right-0 h-3 bg-gradient-to-r from-purple-400 via-pink-400 to-orange-400"></div>
        </div>
      </div>
    );
  }
);

ShareRewindSlideBase.displayName = 'ShareRewindSlideBase';

export default ShareRewindSlideBase;

